import { isResourceDetailImageBookmark, isResourceDetailBookmark, isResourceDetailHighlight, isResourceDetailFolder, isResourceDetailNotepad, isResourceDetailEmail, isResourceDetailDocument, isResourceDetailImage, isResourceDetailVideo, isResourceDetailAudio, isResourceDetailDefault } from '../../../resources/utils/resourceDetailGuards.js';
import React__default from 'react';

const ResourceDataContext = React__default.createContext({});
const useResourceDataContext = () => React__default.useContext(ResourceDataContext);
const useResourceDataContextSafe = () => {
  const context = useResourceDataContext();
  if (!context.resource) {
    throw new Error("ResourceDataContext is used without a resource outside guarded area");
  }
  return context;
};
const useResourceBookmarkDataSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailBookmark(context.resource)) {
    throw new Error("Not a bookmark");
  }
  return context;
};
const useResourceHighlightDataSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailHighlight(context.resource)) {
    throw new Error("Not a highlight");
  }
  return context;
};
const useResourceImageDataSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailImage(context.resource)) {
    throw new Error("Not an image resource");
  }
  return context;
};
const useResourceVideoDataContextSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailVideo(context.resource)) {
    throw new Error("Not a video resource");
  }
  return context;
};
const useResourceAudioDataContextSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailAudio(context.resource)) {
    throw new Error("Not an audio resource");
  }
  return context;
};
const useResourceDocumentDataContextSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailDocument(context.resource)) {
    throw new Error("Not a document resource");
  }
  return context;
};
const useResourceDefaultDataContextSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailDefault(context.resource)) {
    throw new Error("Not a file resource");
  }
  return context;
};
const useResourceNotepadDataContextSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailNotepad(context.resource)) {
    throw new Error("Not a notepad resource");
  }
  return context;
};
const useResourceEmailDataContextSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailEmail(context.resource)) {
    throw new Error("Not an email resource");
  }
  return context;
};
const useResourceFolderDataContextSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailFolder(context.resource)) {
    throw new Error("Not a folder resource");
  }
  return context;
};
const useResourceImageBookmarkDataContextSafe = () => {
  const context = useResourceDataContextSafe();
  if (!isResourceDetailImageBookmark(context.resource)) {
    throw new Error("Not an image bookmark resource");
  }
  return context;
};

export { ResourceDataContext, useResourceAudioDataContextSafe, useResourceBookmarkDataSafe, useResourceDataContext, useResourceDataContextSafe, useResourceDefaultDataContextSafe, useResourceDocumentDataContextSafe, useResourceEmailDataContextSafe, useResourceFolderDataContextSafe, useResourceHighlightDataSafe, useResourceImageBookmarkDataContextSafe, useResourceImageDataSafe, useResourceNotepadDataContextSafe, useResourceVideoDataContextSafe };
//# sourceMappingURL=resourceDataContext.js.map
